import Vue from  'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

// var option = {
//     baseUrl: 'https://wt.franklin.com.tw',
//     headers: {
//         'Content-Type': 'application/json'
//     }
// }

// var franklinApi = axios.create(option);

Vue.use(VueAxios, axios);